import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '@/app/shared/interfaces';
import { UserRole } from '@qc/shared';

export const selectAuthState = createFeatureSelector<AuthState>('auth');
export const selectUser = createSelector(selectAuthState, (state: AuthState) => state.user);
export const selectIsLoggedIn = createSelector(selectAuthState, (state: AuthState) => state.isLoggedIn);
export const selectIsLoading = createSelector(selectAuthState, (state: AuthState) => state.isLoading);
export const selectAuthError = createSelector(selectAuthState, (state: AuthState) => state.error);
export const selectRefreshToken = createSelector(selectAuthState, (state: AuthState) => state.tokens?.refreshToken);
export const selectAuthChallengeToken = createSelector(
    selectAuthState,
    (state: AuthState) => state.challenge?.authChallengeToken,
);
export const selectChallengeInfo = createSelector(selectAuthState, (state: AuthState) => ({
    type: state.challenge?.challengeType,
    reason: state.challenge?.challengeReason,
    delivery: state.challenge?.challengeDelivery,
}));
export const selectHasChallenge = createSelector(
    selectAuthState,
    (state: AuthState) => !!state.challenge?.authChallengeToken,
);
export const selectTotpData = createSelector(selectAuthState, (state: AuthState) => ({
    otpAuthUri: state.challenge?.otpAuthUri,
    secretKey: state.challenge?.secretKey,
}));
export const selectUserRole = createSelector(selectUser, (user) => user?.role);
export const selectIsAdmin = createSelector(selectUserRole, (role) => role === UserRole.SYSTEM_ADMIN);
export const selectAuthInitialized = createSelector(selectAuthState, (state: AuthState) => state.initialized);
